/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
export enum SessionStorageKeyTemplates {
  instanceId = "spgiFusionSystem:window:${windowName}:app:${appId}:instanceId",
}
